import * as z from "zod/v4";
import { IntegrationV2Schema } from "./integration-v2.js";

const GetIntegrationsV2ResponseSchema_ = z.object({
  integrations: z.array(IntegrationV2Schema),
});
export const GetIntegrationsV2ResponseSchema: z.ZodType<GetIntegrationsV2Response> =
  GetIntegrationsV2ResponseSchema_;
export interface GetIntegrationsV2Response
  extends z.infer<typeof GetIntegrationsV2ResponseSchema_> {}
